const initialState = {
  aiLandingPageData: {},
  faqUnreleasedImagery: {},
  homeHero: {},
  homePageData: {},
  inspirePageData: {},
  musicPageData: {},
  videoEditor: {
    showVideoSubscriptions: false,
  },
};

export default initialState;
